/**
 * Timing and presentation controls for the pressure-release section.
 * DOM copy and the dedicated Three.js scene both read from this object so the
 * mechanical opening and the violet release stay in sync.
 */
export const IGNITION_TUNING = {
  fullViewRatio: 0.96,
  resetViewRatio: 0.2,
  fullViewHoldMs: 1_000,
  resetDelayMs: 320,
  energizedStateDelayMs: 1_950,
  product: {
    // Dedicated articulated FBX, normalized to 4.05 units without changing UVs.
    labelOffset: 50 / 360,
    modelYawDegrees: 214,
    tiltDegrees: -9,
    topHeight: 2.04,
    topScale: 0.335,
    topYawDegrees: 164,
    cameraTargetY: 2.1,
    cameraDesktop: { x: 0.65, y: 4.7, z: 3.8 },
    cameraMobile: { x: 0.55, y: 5.1, z: 4.4 },
  },
  energy: {
    effectScale: 0.55,
    columnWidth: 9.6,
    glowSize: 5.5,
    glowPulse: 0.12,
    lightIntensity: 7,
  },
  reflections: {
    environmentIntensity: 0.7,
    metalIntensity: 1.1,
    metalRoughness: 0.22,
    labelIntensity: 0.65,
  },
  scene: {
    tensionMs: 120,
    tabOpenMs: 240,
    sealDelayMs: 30,
    sealOpenMs: 120,
    energyDelayMs: 330,
    energyRiseMs: 620,
    tabOpenDegrees: 58,
    sealOpenDegrees: 54,
    idleDriftMs: 9_200,
  },
} as const
